import React, { memo } from "react";
import { Box, TableCell, TableRow, Typography, alpha } from "@mui/material";
import { spinnerRingOuterSx, centeredColSx } from "./styles";

const SpinnerSmall = () => (
  <Box sx={{ width: 40, height: 40, position: "relative" }}>
    <Box
      sx={{
        ...spinnerRingOuterSx,
        border: "2px solid",
        borderColor: "divider",
        borderTopColor: "primary.main",
      }}
    />
  </Box>
);

const LoadingRow = ({ colSpan }) => (
  <TableRow>
    <TableCell colSpan={colSpan} align="center" sx={{ py: 6, borderBottom: "none" }}>
      <Box sx={centeredColSx}>
        <SpinnerSmall />
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          Cargando datos...
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
);

const EmptyRow = ({ colSpan }) => (
  <TableRow>
    <TableCell colSpan={colSpan} align="center" sx={{ py: 8, borderBottom: "none" }}>
      <Box sx={centeredColSx}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.1),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" color="info.main" sx={{ fontWeight: 700 }}>
            0
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          No se encontraron registros
        </Typography>
        <Typography variant="caption" color="text.disabled">
          Intenta con otra búsqueda o agrega un nuevo registro
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
);

export { LoadingRow, EmptyRow };
